module.exports = {"components.auth.authFooter.linkText.learnMore":"さらに詳しく","components.auth.authFooter.linkText.privacy":"プライバシー","components.auth.authFooter.link.privacy":"https://choosemuse.com/legal/#PrivacyPolicy","components.auth.authFooter.linkText.contactUs":"お問い合わせ"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/components/Auth/AuthFooter/AuthFooter.json
// module id = 828
// module chunks = 0